module.exports = __webpack_public_path__ + "fonts/Glitch inside.0508b6f4.otf";